<div class="boxes">
  <div class="boxes__selection">
    <div class="boxes__selection-wrapper">
      @for (box of store.boxes(); track box.id; let i = $index) {
      <app-box-item [box]="box" [index]="i"></app-box-item>
      }
    </div>
    <div class="boxes__selection-result">
      <button (click)="store.clearBoxes()">X</button>
      <span>Total value:</span>
      <b>{{ store.totalValue() }}</b>
    </div>
  </div>
  @if (store.activeBox()) {
  <div class="boxes__options">
    Choose option
    <div class="boxes__options-wrapper">
      @for (option of store.options(); track option.id) {
      <app-option [option]="option"></app-option>
      }
    </div>
  </div>
  }
</div>
